import { Button } from '@chakra-ui/react';
import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const BackButton = ({
  onClick,
  label,
  color,
}: {
  onClick?: () => void;
  label?: string;
  color?: string;
}) => {
  const navigate = useNavigate();
  return (
    <Button
      leftIcon={<ChevronLeft />}
      fontSize={'16px'}
      color={color || 'text.400'}
      variant={'link'}
      fontWeight={600}
      onClick={() => {
        if (!onClick) {
          navigate(-1);
        } else {
          onClick();
        }
      }}
    >
      {label || 'Back'}
    </Button>
  );
};
